/**
 * Model to manage rule groups related data.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class RuleGroup {
    groupId: number;
    groupName: string;
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/rule-group.model.ts